<div class="relative w-full my-5">
  <div class="relative w-full h-[200px]" [class.opacity-0]="!chartFinished()" [class.opacity-100]="chartFinished()">
    <div
      echarts
      class="w-full h-full pr-6"
      [options]="chartOption()"
      (chartClick)="onChartClick($event)"
      (chartInit)="onChartInit($event)"
      (chartFinished)="onChartFinished()"
    ></div>

    <button
      mat-icon-button
      class="!absolute bottom-1 -right-3 2xl:right-0 z-10 mat-secondary-gray-border-button-color"
      (click)="selectNextPoint()"
    >
      <app-icon src="/icons/arrow-right.svg" alt="Next" [size]="12" />
    </button>
  </div>

  @if (!chartFinished()) {
    <div class="absolute inset-0">
      <div class="w-full h-full flex">
        <div class="w-full h-full">
          <app-skeleton-loader
            [columns]="skeletonGraphColumns"
            [rows]="skeletonGraphRows"
            [showColumns]="false"
            [showPaginator]="false"
            [hasRowLines]="false"
          />
        </div>

        <div class="h-6 flex self-end mb-1">
          <ngx-skeleton-loader class="h-6 w-6" [theme]="{ width: '24px', height: '24px', 'border-radius': '100vw' }" />
        </div>
      </div>
    </div>
  }
</div>
